import { put, takeLatest } from 'redux-saga/effects'
import { notification } from 'antd'

import * as actions from './actions'
import actionTypes from './actionTypes'
import i18next from 'i18next'
import reportError from '../reportError'
import restUtils from '../restUtils'

const endpoints = {
  deviceMapping: 'device',
  registerDevice: 'device/create-with-device',
  shipOptions: 'device/ships',
}

function* requestDevices() {
  return yield restUtils.get({
    endpoint: endpoints.deviceMapping,
    setRequestSuccessful: actions.devicesRequestSuccessful,
    setRequestUnsuccessful: actions.devicesRequestUnsuccessful,
    setRequestingState: actions.setRequestingDevices,
  })
}

export function* watchRequestDevices() {
  yield takeLatest(actionTypes.REQUEST_DEVICES, requestDevices)
}

function* requestShipOptions() {
  return yield restUtils.get({
    endpoint: endpoints.shipOptions,
    setRequestSuccessful: actions.shipOptionsRequestSuccessful,
    setRequestUnsuccessful: actions.shipOptionsRequestUnsuccessful,
    setRequestingState: actions.setRequestingShipOptions,
  })
}

export function* watchRequestShipOptions() {
  yield takeLatest(actionTypes.REQUEST_SHIP_OPTIONS, requestShipOptions)
}

function* registerDeviceSaga({ payload }) {
  const { payload: body, onSuccess } = payload

  yield put(actions.setRegisteringDevice(true))
  yield put(actions.setRegisterDeviceError(null))

  try {
    const response = yield restUtils.postRequest(endpoints.registerDevice, body)

    if (response?.ok || response?.status === 200 || response?.status === 201) {
      yield put(actions.setRegisteringDevice(false))

      notification['success']({
        message: i18next.t('deviceManagement.registerDrawer.successMessage'),
      })

      // Refresh device list
      yield put(actions.requestDevices())

      if (onSuccess) {
        onSuccess()
      }
    } else {
      const errorMsg =
        response?.body?.message ||
        i18next.t('deviceManagement.registerDrawer.errorMessage')

      yield put(actions.setRegisterDeviceError(errorMsg))
      yield put(actions.setRegisteringDevice(false))

      reportError(`Failed to register device. Status: ${response?.status}`)
    }
  } catch (error) {
    const errorMsg =
      error?.message ||
      i18next.t('deviceManagement.registerDrawer.errorMessage')

    yield put(actions.setRegisterDeviceError(errorMsg))
    yield put(actions.setRegisteringDevice(false))

    reportError(`Failed to register device: ${error}`)
  }
}

export function* watchRegisterDevice() {
  yield takeLatest(actionTypes.REGISTER_DEVICE, registerDeviceSaga)
}
